import React, { useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FROST_PROBE_CONFIG, REST_API } from '@awp/constants';
import { GetJson } from '@awp/helpers/fetchReact';
import Table from '@components/table';
import SoilProfileService from '@components/WeatherStationAdmin/Placement/SoilProfile/SoilProfileService';

const SoilProfile = ({ placement }) => {
  const dispatch = useDispatch();
  const [soilLayers, setSoilLayers] = useState([]);
  const { soilTypes } = useSelector((state) => state.soilTypes);

  const soilProfileService = new SoilProfileService();

  const fetchSoilProfileData = async (sensorPlacementId) => {
    const url = `${REST_API.PLACEMENT_SOIL_LAYER}${sensorPlacementId}`;
    const response = await GetJson(url);
    const records = await response.json();
    setSoilLayers(records);
  };

  useEffect(() => {
    if (placement?.SensorTypeName === FROST_PROBE_CONFIG.TITLE_NAME) {
      fetchSoilProfileData(placement.SensorPlacementId);
    }
  }, [dispatch, placement]);

  const filteredLayers = soilLayers.sort((a, b) => a.TopmostRelativeElevation - b.TopmostRelativeElevation);

  const soilTypeCell = (row) => {
    const soilType = soilTypes.find((type) => row.row.original.SoilTypeId == type.Id) || {};
    const patternBase64 = soilType.PatternImage || null;
    const [previewUrl, setPreviewUrl] = useState(null);

    useEffect(() => {
      if (patternBase64 && !previewUrl) {
        const dataUrl = `data:image/jpeg;base64,${patternBase64}`;
        setPreviewUrl(dataUrl);
      }
    }, [patternBase64, previewUrl]);

    const patternImageUrl = previewUrl;

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {patternImageUrl ? (
          <img
            src={patternImageUrl}
            alt={`${soilType.Code || row.row.original.SoilTypeId} pattern`}
            className="soil-pattern"
            style={{ width: '40px', height: '40px', verticalAlign: 'middle', objectPosition: '0 0', objectFit: 'none' }}
          />
        ) : (
          <div className="no-pattern">No Pattern</div>
        )}
        <div>
          <span className="soil-code" style={{ fontWeight: 'bold', marginRight: '10px' }}>
            {soilType.Code || row.row.original.SoilTypeId}
          </span>
          <span
            className="soil-description"
            style={{
              color: '#333',
              fontSize: '12px',
              width: '150px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {soilType.Description || 'Unknown'}
          </span>
        </div>
      </div>
    );
  };

  const columns = useMemo(() => soilProfileService.getColumns({ soilTypeCell }), [soilTypes]);

  if (placement?.SensorTypeName !== FROST_PROBE_CONFIG.TITLE_NAME) {
    return <div className="soil-profile-empty"></div>;
  }

  if (filteredLayers.length === 0) {
    return (
      <div className="soil-profile no-data">
        <h4>Unknown Soil Profile</h4>
      </div>
    );
  }

  return (
    <div className="soil-profile" style={{ margin: '10px 0 20px 0' }}>
      <Table
        columns={columns}
        data={filteredLayers}
        fetchData={() => {}}
        defaultSortBy="TOPMOST_RELATIVE_ELEVATION_MILLIMETRES"
      />
    </div>
  );
};

export default SoilProfile;
